import * as React from "react";
import Svg, { Path } from "react-native-svg";

const SvgComponent = (props) => (
  <Svg
    {...props}
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.667 9a8.333 8.333 0 1 1 16.666 0A8.333 8.333 0 1 1 .667 9Zm9.166-3.333a.833.833 0 1 0-1.666 0 .833.833 0 0 0 1.666 0ZM9 13.166a.833.833 0 0 0 .833-.834V9a.833.833 0 1 0-1.666 0v3.333a.833.833 0 0 0 .833.833Z"
      fill={props.fill || "#000"}
      fillOpacity={0.56}
    />
  </Svg>
);

export default SvgComponent;
